// Styles
import '@mdi/font/scss/materialdesignicons.scss'

// Types

// Composables
import { createVuetify } from 'vuetify'
import { mdi } from 'vuetify/iconsets/mdi'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

import type { ThemeDefinition } from 'vuetify'

export const light: ThemeDefinition = {
  dark: false,
  colors: {
    'ui-alert': '#FD9200',
    'ui-unanswered': '#7B8690',
    'ui-temporarily-saved': '#00B6FF',
    'ui-submitted': '#0063FF',
    'ui-score-rated': '#004ABF',
    'ui-ended': '#CACACA',
    'ui-auto-scored': '#004ABF',
    'ui-graph-blue-1': '#004ABF',
    'ui-graph-blue-2': '#0063FF',
    'ui-graph-blue-3': '#00B6FF',
    'ui-graph-blue-4': '#66FBFF',
    'ui-graph-blue-5': '#D8F4FF',
    'ui-graph-blue-6': '#7B8690',
    'ui-graph-blue-7': '#5D95FF',
    'ui-gray1': '#CACACA',
    'ui-gray2': '#EBEBEB',
    'ui-gray3': '#B9B9B9',
    'ui-gray4': '#3C3C3C',
    'ui-gray5': '#f6f6f6',
    'ui-black': '#000000',
    'ui-text-black': '#3C3C3C',
    'ui-text-gray-1': '#777777',
    'ui-text-gray-2': '#CACACA',
    'ui-text-white': '#FFFFFF',
    'ui-white': '#FFFFFF',
    'ui-background': '#F6F7F8',
    'ui-admin-green': '#00a096',

    'white': '#ffffff',
    'primary': '#0063ff',
    'primary-lighten-2': '#004ABF',
    'primary-lighten-3': '#D8F4FF',
    'primary-darken-1': '#00B6FF',
    'secondary': '#CACACA',
    'secondary-lighten-1': '#EBEBEB',
    'secondary-lighten-2': '#F6F7F8',
    'secondary-darken-3': '#777777',
    'teal': '#00b9ff',
    'info': '#f8f8f8',
    'accent': '#8c9eff',
    'error': '#fd9200',
    'low': '#7B8690',
    'status-unanswered': '#7b8690',
    'status-under-evaluation': '#00b6ff',
    'status-evaluated': '#0063ff',
  },
}

export default createVuetify(
  // https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
  {
    ssr: false,
    components,
    directives,
    theme: {
      defaultTheme: 'light',
      themes: {
        light,
      },
    },
    icons: {
      defaultSet: 'mdi',
      sets: {
        mdi,
      },
    },
  },
)
